import React from "react";

import { LinearProgress } from "@material-ui/core";

import { logError } from "../../../utils/appUtils";

const computeCompleted = (record) => {
  let processedLocations = {};
  let completedCount = 0;

  try {
    if (typeof record.processedLocations === "string") {
      processedLocations = !record.processedLocations
        ? {}
        : JSON.parse(record.processedLocations);
    } else {
      processedLocations = !record.processedLocations
        ? {}
        : record.processedLocations;
    }
  } catch (error) {
    logError("audits:AuditProgressBar:computeCompleted", error, false);
  }

  Object.keys(processedLocations).forEach((key) => {
    if (processedLocations[key].completed === processedLocations[key].total)
      completedCount++;
  });
  return completedCount;
};

export const AuditProgressBar = ({ record, ...props }) => {
  if (!record) return null;
  return (
    <LinearProgress
      color="secondary"
      variant="determinate"
      value={(computeCompleted(record) / record.locations.length) * 100}
      style={{ width: "100px" }}
    />
  );
};
